module.exports = __webpack_public_path__ + "img/9791159923272.5b0cf3b3.jpg";